module.exports = __webpack_public_path__ + "img/backgroundFeature1.de8a6b60.svg";